import FanLiveEventTicketPage from "./FanLiveEventTicketPage";

export default FanLiveEventTicketPage;